/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rangeLabel': {
    width: 14,
    height: 48,
    viewBox: '0 0 14 48',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#566473" x="5" y="11" width="2" height="36" rx="1"/><circle pid="1" _stroke="#566473" stroke-width="2" _fill="#FFF" cx="6" cy="6" r="6"/></g>'
  }
})
